import {
  CardElement,
  Elements,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { useCreateIntentAndDropOutAttendee } from 'api/Event/Dropin'
import { infoMessage } from 'api/global'
import ButtonSpinner from 'components/global/ButtonSpinner'
import CustomModal from 'components/global/CustomModal'
import React from 'react'
import { eventAttendanceStore } from 'state/event/eventAttendance'

const FamilyNotFound = () => {
  const stripe = useStripe()
  const elements: any = useElements()
  const cardElementOptions = {
    hidePostalCode: true,
  }
  const {
    participantData,
    accountNotFoundModalOpen,
    setAccountNotFoundModalOpen,
    setCheckInOutModalOpen,
    familyEmail,
    dropInPricing,
  } = eventAttendanceStore(store => ({
    participantData: store.participantData,
    accountNotFoundModalOpen: store.accountNotFoundModalOpen,
    setAccountNotFoundModalOpen: store.setAccountNotFoundModalOpen,
    setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    familyEmail: store.familyEmail,
    dropInPricing: store.dropInPricing,
  }))

  const {
    mutate: createIntentAndDropOout,
    isLoading: isCreateIntentAndDropOutLoading,
  } = useCreateIntentAndDropOutAttendee()

  const handleSubmit = async (event: any) => {
    event.preventDefault()
    const cardElement = elements.getElement(CardElement)
    console.log('Card Element:', cardElement)
    if (!cardElement) {
      return infoMessage('Card element is not available')
    }
    if (!stripe || !elements) {
      return
    }

    stripe
      .createPaymentMethod({
        type: 'card',
        card: cardElement,
      })
      .then(function (result) {
        if (result.error) {
          infoMessage("Couldn't create a payment method")
        } else {
          const payload = {
            amount: dropInPricing,
            paymentMethodId: result.paymentMethod.id,
            email: familyEmail,
            checkInId: participantData.checkInId,
          }
          createIntentAndDropOout(payload, {
            onSuccess: () => {
              setAccountNotFoundModalOpen(false)
            },
          })
        }
      })
  }

  const closeModal = () => {
    setCheckInOutModalOpen(true)
    setAccountNotFoundModalOpen(false)
  }

  return (
    <>
      <CustomModal
        openModal={accountNotFoundModalOpen}
        isCloseModalCustom={true}
        closeModal={closeModal}
        title="Add card"
        width={600}
        footer={false}
      >
        <form onSubmit={handleSubmit}>
          <div className="py-15px px-10px border-1px radius-12 ">
            <CardElement options={cardElementOptions} />
          </div>
          <button
            type="submit"
            disabled={!stripe || !elements}
            className="prim-btn mt-20px w-full mb-20px"
          >
            {isCreateIntentAndDropOutLoading ? (
              <ButtonSpinner size={20} color="#000" />
            ) : (
              `Pay $${dropInPricing}`
            )}
          </button>
        </form>
      </CustomModal>
    </>
  )
}

export default FamilyNotFound
